export default {
 apiKey: "AIzaSyBfk9cdRIU7kDqcl_lyKpZYkUSrnStRMM0",
  authDomain: "emc-mdnacloud-demo1-t.firebaseapp.com",
  projectId: "emc-mdnacloud-demo1-t",
  storageBucket: "emc-mdnacloud-demo1-t.appspot.com",
  messagingSenderId: "1078690499436",
  appId: "1:1078690499436:web:957e86b934e483cfae4149"
}